<template>
  <!-- 文章详情 -->
  <div class="my-articleDetail">
    <!-- 文章详情 -->
    <div class="title">
      {{ defaultProxyDetails && defaultProxyDetails.title }}
    </div>
    <div class="article-main">
      <!-- <img :src="defaultProxyDetails.icon" alt="" /> -->
      <VideoPlayerAnswer class="articleDetail-video" v-if="analysisVideo && analysisVideo.appId" ref="video"
                         :playerVideo="analysisVideo"></VideoPlayerAnswer>
      <div v-html="_pxToRem(defaultProxyDetails.content)" ref="richText"></div>
    </div>
    <returnBack></returnBack>
    <footerCom :defaultProxyDetails="defaultProxyDetails" @handleLike="handleLike" @handleCollect="handleCollect"
               @handleNext="handleNext"></footerCom>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog && cDialog.content }}</div>
    </custom-dialog>
  </div>
</template>
<script>
import returnBack from '@/views/person/components/returnBack.vue'
import CustomDialog from '@/views/cartoJourney/components/CustomDialog.vue'

import {
  getProxyMobileDetails,
  articleUnLike,
  articleLike,
  articleUserCollect,
  articleUnUserCollect,
} from '@/api/article'
import withRouteTracking from '@/utils/withRouteTracking'
import footerCom from './components/footerCom.vue'
import VideoPlayerAnswer from '@/views/home/components/VideoPlayerAnswer'
import MxTcVideo from './MxTcVideo'
import Style from '@/utils/Style.js'
import {getShareInfo} from '@/utils/wxShare'
import {dictionaryDownList} from '../../api/article'
import {ImagePreview} from 'vant'
import {getUrlParms} from '../../utils/util'

function getURLParameters(url) {
  const params = {}
  const regex = /[?&]([^=#]+)=([^&#]*)/g
  let match

  while ((match = regex.exec(url)) !== null) {
    params[match[1]] = match[2]
  }
  return params
}

const UserProfile = {
  name: 'ArticleDetails',
  mixins: [Style, MxTcVideo],
  components: {
    returnBack,
    footerCom,
    VideoPlayerAnswer,
    CustomDialog
  },
  data() {
    return {
      proxyId: '',
      defaultProxyDetails: {},
      defaultProxyDetailsId: '',
      analysisVideo: {},
      menuList: [],
      columnId: '',
      cDialog: {
        visible: false,
        showCancelButton: false,
        confirmButtonText: '我知道了',
        content: '该文献已经下架',
        showCloseIcon: false,
        cancel: () => {
          this.cDialog.close()
        },
        confirm: () => {
          this.cDialog.close()
        },
        close: () => {
          this.cDialog.visible = false
          this.$router.back()
        }
      },
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    shareDesc() {
      const item = this.menuList.find(item => item.id === this.columnId)
      if (item) {
        return item.value
      }
      return ''
    }
  },
  watch: {
    '$route.query.id': function (newVal, oldVal) {
      window.location.reload()
    },
  },
  beforeDestroy() {
    setTimeout(() => {
      sessionStorage.removeItem('video-track-cache')
    }, 300)
  },
  async mounted() {
    window.sessionStorage.setItem('mainId', this.$route.query.id)
    window.sessionStorage.setItem('serviceId', this.$route.query.id)
    let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : window.sessionStorage.getItem('entrance')
    window.sessionStorage.setItem('entrance', entrance)
    const campId = getUrlParms('businessId') || ''
    const channel = (entrance === '1' || entrance === '2' || entrance === '3') ? entrance : getUrlParms('channel') || ''
    setTimeout(() => {
      sessionStorage.setItem('video-track-cache', JSON.stringify({
        entrance,
        campId,
        channel,
      }))
    }, 400)
    this.proxyId = this.$route.query.id
    await this.handleDictionaryDownList()
    await this.handleLoad()
  },
  methods: {
    handleShareMethod() {
      getShareInfo({
        title: this.defaultProxyDetails.title,
        titleTimeLine: this.defaultProxyDetails.title,
        desc: this.shareDesc,
        link: window.location.href,
        linkTimeLine: window.location.href,
        images: this.defaultProxyDetails.icon,
      })
    },
    /**
     * @method
     * @name: _handleRichVideo
     * @description: 处理富文本视频
     * @param: {Function} [playFn] 视频播放
     * {String} [content] parent
     */
    _handleRichVideo({eachFn} = {}) {
      let videos = []
      this.$nextTick(() => {
        videos = document.querySelectorAll(`.edui-upload-video`)
        videos.forEach((video, index) => {
          if (eachFn && typeof eachFn === 'function') {
            eachFn(video, index, index === videos.length - 1)
          }
        })
      })
      return videos
    },
    // 栏目列表
    handleDictionaryDownList() {
      const params = {
        typeCode: 'LITERATURE_SECTION',
        dataStatus: 1
      }
      dictionaryDownList(params).then(res => {
        if (res.code === 0) {
          this.menuList.push(...res.data)
        }
      })
    },
    _handleRichImage() {
      this.$nextTick(() => {
        let images = this.$refs.richText.querySelectorAll('img')
        images.forEach(img => {
          img.addEventListener('click', () => {
            ImagePreview({
              images: [img.src],
              showIndex: false,
              closeable: true,
            })
          })
        })
      })
    },
    handleLoad() {
      getProxyMobileDetails(this.proxyId).then((res) => {
        this.defaultProxyDetails = res.data
        this.analysisVideo = res.data
        this.analysisVideo.baseId = this.$route.query.id
        this.analysisVideo.fileId = res.data.vodFileId
        this.defaultProxyDetailsId = res.data.id
        this.columnId = res.data.columnId
        if (this.analysisVideo.state === 3) {
          this.cDialog.visible = true
        }
        this.handleShareMethod()
        this._handleRichVideo({
          eachFn: async (video, index, isLast) => {
            const rd = Math.floor(Math.random() * 10 + 1)
            const marking = `${new Date().valueOf()}${rd}`
            const id = `rich-video-${marking}`
            video.setAttribute('id', id)
            let data = getURLParameters(video.src)
            if (!data.poster && video.getAttribute('poster')) {
              data.poster = video.poster
            }
            this.initVideo(id, data)
          },
        })
        this._handleRichImage()
      })
    },
    handleNext(val) {
      this.$router.replace({
        path: '/articleDetails',
        query: {
          id: val
        }
      })
    },
    // 点赞
    handleLike() {
      if (this.defaultProxyDetails.isLike) {
        const params = {
          userId: this.userInfo.id,
          baseId: this.defaultProxyDetailsId,
          type: 6,
          kind: 6,
        }
        articleUnLike(params).then((res) => {
          if (res.code === 0) {
            this.$toast('取消点赞成功')
            this.handleLoad()
          }
        })
      } else {
        const params = {
          type: 6,
          likeId: this.defaultProxyDetailsId,
          likeTitle: this.defaultProxyDetails.title,
          userId: this.userInfo.id,
          openId: this.userInfo.iepOpenId,
          cover: this.defaultProxyDetails.icon,
          kind: 6,
        }
        articleLike(params).then((res) => {
          if (res.code === 0) {
            this.$toast('点赞成功')
            this.handleLoad()
          }
        })
      }
    },
    // 收藏
    handleCollect() {
      if (this.defaultProxyDetails.isCollect) {
        const params = {
          baseId: this.defaultProxyDetailsId,
          baseType: 6,
          userId: this.userInfo.id,
          userName: this.userInfo.realName,
        }
        articleUnUserCollect(params).then((res) => {
          if (res.code === 0) {
            this.$toast('取消收藏成功')
            this.handleLoad()
          }
        })
      } else {
        const params = {
          userId: this.userInfo.id,
          baseId: this.defaultProxyDetailsId,
          baseType: 6,
        }
        articleUserCollect(params).then((res) => {
          if (res.code === 0) {
            this.$toast('收藏成功')
            this.handleLoad()
          }
        })
      }
    },
  },
}
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.my-articleDetail {
  background: #F9F8F7;
  min-height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  flex-direction: column;

  .title {
    padding: 16px 16px 12px;
    font-weight: 600;
    font-size: 18px;
    color: #222528;
    line-height: 20px;
    text-align: left;
    font-family: BlinkMacSystemFont, Helvetica Neue, Source Han Sans CN, Source Han Sans CN, Hiragino Sans GB, Arial, sans-serif;
  }

  .article-main {
    margin: 12px;
    padding: 8px;
    height: calc(100vh - 160px);
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    overflow-y: auto;

    img {
      width: 100%;
      margin-bottom: 8px;
    }

    .desc {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 21px;
    }

    .pd8 {
      padding-bottom: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/article/articleDetails.vue